import { FunctionComponent, memo } from 'react';
import { ConfigExternalLink } from '../ExternalLinks';

import classNames from 'classnames';
import classes from './ExternalLinkCard.module.scss';

export const ExternalLinkCard: FunctionComponent<ConfigExternalLink> = memo(
  ({ url, headline, description, image }) => {
    return (
      <a className={classes['external-link-card']} href={url} target={'_blank'} rel={'noreferrer'}>
        <div
          className={classNames(classes['external-link-card__content'], {
            [classes['external-link-card__content--with-image']]: Boolean(image),
          })}
        >
          <div className={classes['external-link-card__headline']}>{headline}</div>
          {description && (
            <div className={classes['external-link-card__description']}>{description}</div>
          )}
        </div>
        {image && (
          <div
            className={classes['external-link-card__image']}
            style={{ backgroundImage: `url(${image})` }}
          />
        )}
      </a>
    );
  }
);
